import { calculateStake } from '@superbet-group/betting.lib.payments';
import { AppConfig } from '@superbet-group/web.lib.config';
import { instanceGuard } from '@superbet-group/web.lib.utilities';
import { BetSlipPurchaseType } from '@superbet-group/web.types';

import SingletonError from '@core/services/common/errors/SingletonError';

export class TaxService {
    private static instance?: TaxService;
    public readonly offlineTax: number;
    public readonly onlineTax: number;
    private readonly handlingFeeInverse: boolean;

    private constructor({ betSlip }: AppConfig) {
        if (TaxService.instance) {
            throw new SingletonError(this.constructor.name);
        }
        this.offlineTax = betSlip.offlineTax;
        this.onlineTax = betSlip.onlineTax;
        this.handlingFeeInverse = betSlip.handlingFeeInverse;
    }

    public static getInstance(): TaxService {
        return instanceGuard(TaxService.instance);
    }

    public static createInstance(config: AppConfig): TaxService {
        if (!TaxService.instance) {
            TaxService.instance = new TaxService(config);
        }
        return TaxService.instance;
    }

    public getStakeTaxByPurchaseType(purchaseType: BetSlipPurchaseType): number {
        switch (purchaseType) {
            case BetSlipPurchaseType.online:
                return this.onlineTax;
            case BetSlipPurchaseType.offline:
                return this.offlineTax;
        }

        return 0;
    }

    public getNetStake(stake: number, taxMethod: BetSlipPurchaseType | number): number {
        let taxPercentage;
        // REFACTOR use only BetSlipPurchaseType
        if (typeof taxMethod === 'number') {
            taxPercentage = taxMethod;
        } else {
            taxPercentage = this.getStakeTaxByPurchaseType(taxMethod);
        }
        if (taxPercentage <= 0) {
            return stake;
        }

        return calculateStake(stake, taxPercentage, this.handlingFeeInverse, null).amount;
    }

    public static clearInstance(): void {
        if (process.env.NODE_ENV !== 'test') {
            throw new Error('For use in tests only');
        }

        if (TaxService.instance) {
            delete TaxService.instance;
        }
    }
}
